module.exports = __webpack_public_path__ + "static/media/patrol(34).0130f44c.PNG";